import React from 'react';
import { Tabs } from 'antd';
import { useLocation, Outlet, useNavigate } from 'react-router-dom';

/* extracting Tab pane from Tabs */
const { TabPane } = Tabs;

/* React functional component */
const BagsTabLayout = () => {
  /* extracting navigate from useNavigate() */
  const navigate = useNavigate();
  /* useLocation destructuring */
  const location = useLocation();

  /* function to get the active tab key */
  const getActiveKey = () => {
    if (location.pathname.includes('product')) {
      return 'productBags';
    }
    return 'paddyBags';
  };

  return (
    <div className="tabLayout">
      <Tabs
        defaultActiveKey="paddyBags"
        onTabClick={(key: string) => {
          if (key === 'productBags') {
            navigate('product');
          } else {
            navigate('paddy');
          }
        }}
        activeKey={getActiveKey()}
        tabBarGutter={50}
        destroyInactiveTabPane
      >
        <TabPane tab="Paddy Bags" key="paddyBags">
          <Outlet />
        </TabPane>
        <TabPane tab="Product Bags" key="productBags">
          <Outlet />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default BagsTabLayout;
